<template>
  <main class="md:mx-14 mx-4 grid lg:grid-cols-2 gap-16 pt-10">
    <section class="px-6 py-4 bg-gray-1 lg:w-10/12">
      <div class="font-light text-xs text-root-4">
        <h3 class="font-semibold text-xl text-root-2">Payment Details</h3>
        <p class="leading-loose">
          Every artworks comes with a written note and a wish from us to you
          <br />Start by filling in all these details
        </p>
        <hr class="mt-2" />
        <h3 class="font-semibold text-xl text-root-2 my-6">Art By Silake</h3>
        <hr class="mt-2" />
        <ul class="mt-2 text-root-2">
          <li class="flex items-center justify-between text-xl my-5">
            <span class="font-normal">Sub Total</span>
            <span class="font-semibold">$2,000</span>
          </li>
          <li class="flex items-center justify-between text-xl my-5">
            <span class="font-normal">Fees</span>
            <span class="font-semibold">$20</span>
          </li>
          <hr class="mt-2" />
          <li
            class="flex items-center justify-between text-xl text-primary my-5"
          >
            <span class="font-normal">Total</span>
            <span class="font-semibold">$2,020</span>
          </li>
        </ul>
      </div>
      <p class="font-light text-xs my-1">
        You are about to make payment to ArtBySilake. Click on "makePayment" to
        complete this in 3 simple steps
      </p>
    </section>
    <section class="flex flex-col gap-5 lg:w-10/12">
      <div class="flex items-center justify-between gap-5 mb-10">
        <div>
          <el-avatar
            class="bg-blue-10 flex items-center justify-center"
            :size="80"
          >
            <span class="text-2xl font-normal">SN</span>
          </el-avatar>
        </div>
        <div class="font-light text-xs text-root-4">
          <h3 class="font-semibold text-xl text-root-2">Art By Silake</h3>
          <p class="leading-loose">
            Every artworks comes with a written note and a wish from us to you
          </p>
        </div>
        <h3 class="font-semibold text-xl text-root-2">$2,000</h3>
      </div>
      <!-- form -->
      <el-form
        :model="previewLinkForm"
        :rules="rules"
        label-position="top"
        ref="previewLinkForm"
      >
        <el-form-item prop="name">
          <el-input v-model="previewLinkForm.name" placeholder="Full Name" />
        </el-form-item>
        <el-form-item prop="email">
          <el-input
            v-model="previewLinkForm.email"
            placeholder="Email Address"
          />
        </el-form-item>
        <el-form-item prop="email">
          <el-input
            v-model="previewLinkForm.phone"
            placeholder="Phone Number"
          />
        </el-form-item>
        <el-form-item prop="amount">
          <el-input
            type="number"
            v-model.number="previewLinkForm.amount"
            placeholder="Enter Amount"
          />
        </el-form-item>
        <el-form-item>
          <div class="flex items-center gap-x-4">
            <el-checkbox v-model="previewLinkForm.agree"></el-checkbox>
            <p class="font-light text-xs">
              I agree to
              <span class="text-primary font-semibold">Terms & Condition</span>
              and <span class="text-primary font-semibold">Privacy Policy</span>
            </p>
          </div>
        </el-form-item>
        <el-form-item>
          <o-button
            @click="submitForm('previewLinkForm')"
            class="bg-primary text-white w-full rounded-3xl outline-none border-none mt-7"
            >Make Payment</o-button
          >
        </el-form-item>
      </el-form>
    </section>
    <!-- dialogs -->
    <payment-widget
      v-if="showPaymentWidget"
      :showDialog="showPaymentWidget"
      @closeDialog="closeDialog('showPaymentWidget')"
    />
  </main>
</template>

<script>
export default {
  data () {
    return {
      previewLinkForm: {
        phone: '',
        name: '',
        email: '',
        amount: '',
        agree: false
      },
      rules: {},
      showPaymentWidget: false
    }
  },
  components: {
    PaymentWidget: () =>
      import('@/components/receivePayment/dialogs/PaymentWidget.vue')
  },
  methods: {
    submitForm (formName) {
      this.showDialog('showPaymentWidget')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.$emit('successful')
        } else {
          this.$notify({
            showClose: true,
            message: 'Please fill all inputs correctly',
            type: 'error'
          })
        }
      })
    },
    showDialog (arg) {
      this[arg] = true
    },
    closeDialog (arg) {
      this[arg] = false
    }
  }
}
</script>

<style></style>
